/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_File_Tree_Unsupported_ExtensionInputs */

const es_components_file_tree_unsupported_extension = /** @type {(inputs: Components_File_Tree_Unsupported_ExtensionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta extensión de archivo no es compatible con la ingesta`)
};

const en_components_file_tree_unsupported_extension = /** @type {(inputs: Components_File_Tree_Unsupported_ExtensionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This file extension is not supported for ingestion`)
};

/**
* | output |
* | --- |
* | "This file extension is not supported for ingestion" |
*
* @param {Components_File_Tree_Unsupported_ExtensionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_file_tree_unsupported_extension = /** @type {((inputs?: Components_File_Tree_Unsupported_ExtensionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_File_Tree_Unsupported_ExtensionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_file_tree_unsupported_extension(inputs)
	return en_components_file_tree_unsupported_extension(inputs)
});
export { components_file_tree_unsupported_extension as "components.file_tree.unsupported_extension" }